import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetIssuedCardLockRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetIssuedCardLockResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setIssuedCardLock = (request: SetIssuedCardLockRequest, options?: CashRequestOptions) =>
  post<SetIssuedCardLockRequest, SetIssuedCardLockResponse>('/2.0/cash/set-issued-card-lock', request, {
    ...options,
    rejectOnError: true,
  })
